// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialState } from './initialState'

import {
  ASSIGN_USER_DATA,
} from './types'

export const assignUserData = (userData = initialState) => ({
  type: ASSIGN_USER_DATA,
  userData,
})
